var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',{staticClass:"d-flex"},[_c('v-avatar',[_c('img',{attrs:{"src":_vm.userAvatar,"alt":_vm.userName}})]),_c('div',{staticClass:"ml-3"},[_c('label',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.reporterName))]),_c('label',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.reporterEmail))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }